import { render, staticRenderFns } from "./advertCostDetail.vue?vue&type=template&id=31f5992c&scoped=true"
import script from "./advertCostDetail.vue?vue&type=script&lang=js"
export * from "./advertCostDetail.vue?vue&type=script&lang=js"
import style0 from "./advertCostDetail.vue?vue&type=style&index=0&id=31f5992c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f5992c",
  null
  
)

export default component.exports